import { render } from "./PaymentMethodCard.vue?vue&type=template&id=32ec5f31&scoped=true"
import script from "./PaymentMethodCard.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCard.vue?vue&type=script&lang=js"

import "./PaymentMethodCard.vue?vue&type=style&index=0&id=32ec5f31&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ec5f31"]])

export default __exports__